import React from 'react';
export default function Button({ children, as = 'button', className = '', variant = 'primary', ...rest }) {
  const base = 'inline-flex items-center justify-center transition-colors focus:outline-none ';
  const variants = {
    primary: 'bg-[#FEA12BCC] rounded-[69.32px] font-inter font-medium text-sm px-8 -tracking-[0.02em] text-center hover:bg-[#FEA12B] text-white focus:ring-emerald-600',
    secondary: 'bg-white text-emerald-700 border border-emerald-200 hover:bg-emerald-50 focus:ring-emerald-600',
    ghost: 'bg-[#FFFFFF] text-[#0A0A0A] hover:text-[#FEA12B] font-segoe font-semibold text-sm pt-1 text-center align-middle border-[1.52px] hover:border-[#FEA12B] rounded-[133.68px] transition-all duration-300',
  };
  const Comp = as;
  return (
    <Comp className={`${base} ${variants[variant]} px-5 py-2 ${className}`} {...rest}>
      {children}
    </Comp>
  );
}


